import { render, staticRenderFns } from "./RhDocumentosSecao.vue?vue&type=template&id=e1855c60"
import script from "./RhDocumentosSecao.vue?vue&type=script&lang=js"
export * from "./RhDocumentosSecao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports